import React from 'react';

import { assetTypes } from '../../constants';
import { Input, Select } from '../basic-inputs';

import { ModalFormHeader } from '.';

interface Option {
  id: string;
  label: string;
}

interface AssetFormProps {
  handleChange: (option: Option) => void;
  value: Option;
}

export function AssetForm({ handleChange, value }: AssetFormProps) {
  return (
    <div className="form-container">
      <ModalFormHeader
        icon="group_add"
        header="Asset Information"
      />
      <Select
        id="asset-type"
        label="Asset Type"
        name="asset-type"
        options={assetTypes}
        required
        handleChange={handleChange}
        selectedOption={value}
      />
      <Input id="asset-name" label="Asset Name" required />
      <Input id="description" label="Description" />
    </div>
  );
}
